import { render, staticRenderFns } from "./SalesVelocityWidget.vue?vue&type=template&id=3aadb04f&"
import script from "./SalesVelocityWidget.vue?vue&type=script&lang=js&"
export * from "./SalesVelocityWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports